// extracted by mini-css-extract-plugin
export default {"imgfooter":"Footer_imgfooter__JkjhX","sunfooter":"Footer_sunfooter__gqe39"};